import {
  Button,
  Space,
  Table,
  Modal,
  Card,
  Image,
  Typography,
  Tag,
  Form,
  Input,
  Select,
  Row,
  Col,
} from "antd";
import React, { useEffect, useState } from "react";
import CreateModal from "../../components/scene/createModal";
import { get, post } from "../../utils/http";
import {
  PERMISSION_TAG_COLOR,
  PERMISSION_MAP,
  PERMISSIONS,
  STATUS,
  STATUS_MAP,
  STATUS_TAG_COLOR,
} from "../../utils/consts";

const { Title } = Typography;

function List() {
  const [showScene, setShowScene] = useState(false);
  const [sceneData, setSceneData] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deletingRecord, setDeletingRecord] = useState<any>(null);
  const [form] = Form.useForm();
  const [modules, setModules] = useState<{ id: number; module_name: string }[]>(
    [],
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [reorderingId, setReorderingId] = useState<string | null>(null);

  // 获取模块列表用于筛选
  const fetchModules = async () => {
    try {
      const res = await get("/api/manage/module-list");
      if (res.data.code === 0) {
        setModules(Array.isArray(res.data.data.list) ? res.data.data.list : []);
      }
    } catch (error) {
      console.error("获取模块列表失败:", error);
    }
  };
  const createScene = () => {
    setShowScene(true);
  };

  const columns = [
    {
      title: "场景名称",
      dataIndex: "scene_name",
      key: "scene_name",
      render: (_: any, record: any) => (
        <a href={`/scene/detail/${record.id}`}>{record.scene_name}</a>
      ),
    },
    {
      title: "场景名称翻译",
      dataIndex: "scene_name_en",
      key: "scene_name_en",
    },
    {
      title: "场景描述",
      dataIndex: "scene_desc",
      key: "scene_desc",
    },
    {
      title: "所属模块",
      dataIndex: "module_name",
      key: "module_name",
    },
    {
      title: "所属权限",
      dataIndex: "permission_type",
      key: "permission_type",
      width: 120,
      render: (_: any, record: any) => (
        <Tag
          color={PERMISSION_TAG_COLOR[record.permission_type as PERMISSIONS]}
        >
          {PERMISSION_MAP[record.permission_type as PERMISSIONS]}
        </Tag>
      ),
    },
    {
      title: "封面图",
      dataIndex: "main_pic",
      key: "main_pic",
      width: 120,
      render: (_: any, record: any) =>
        record.main_pic ? (
          <Image
            src={record.main_pic}
            alt={record.scene_name}
            width={80}
            height={80}
            style={{ objectFit: "cover", borderRadius: 4 }}
          />
        ) : (
          <span style={{ color: "#999" }}>暂无封面</span>
        ),
    },
    {
      title: "最后修改时间",
      dataIndex: "modify_time",
      key: "modify_time",
      width: 180,
      render: (time: string) => {
        if (!time) return "-";
        return new Date(time).toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        });
      },
    },
    {
      title: "状态",
      dataIndex: "scene_status",
      key: "scene_status",
      width: 100,
      render: (scene_status: STATUS) => (
        <Tag color={STATUS_TAG_COLOR[scene_status]}>
          {STATUS_MAP[scene_status]}
        </Tag>
      ),
    },
    {
      title: "是否推荐",
      dataIndex: "is_recommend",
      key: "is_recommend",
      width: 100,
      render: (is_recommend: boolean) => (
        <Tag color={is_recommend ? "green" : "default"}>
          {is_recommend ? "是" : "否"}
        </Tag>
      ),
    },
    {
      title: "操作",
      key: "action",
      width: 220,
      fixed: "right" as const,
      render: (_: any, record: any, index: number) => (
        <Space size="middle">
          <a
            style={{
              color: index === 0 ? "#ccc" : undefined,
              cursor: index === 0 ? "not-allowed" : "pointer",
            }}
            onClick={() => index !== 0 && handleReorder(record.id, "up")}
          >
            上移
          </a>
          <a
            style={{
              color: index === dataSource.length - 1 ? "#ccc" : undefined,
              cursor:
                index === dataSource.length - 1 ? "not-allowed" : "pointer",
            }}
            onClick={() =>
              index !== dataSource.length - 1 &&
              handleReorder(record.id, "down")
            }
          >
            下移
          </a>
          <a onClick={() => handleEdit(record)}>编辑</a>
          <a onClick={() => handleDelete(record)}>删除</a>
        </Space>
      ),
    },
  ];

  const getList = async ({
    page = 1,
    filters = {},
  }: {
    page?: number;
    filters?: any;
  }) => {
    try {
      const params = {
        page,
        offset: 20,
        ...filters,
      };
      const res = await get("/api/manage/scene-list", params);
      if (res.data.code === 0) {
        setDataSource(res.data.data.list || []);
        setTotal(res.data.data.total || 0);
        setCurrentPage(page);
      }
    } catch (err) {
      console.error("获取场景列表失败:", err);
    }
  };

  // 处理查询
  const handleSearch = () => {
    const values = form.getFieldsValue();
    getList({ page: 1, filters: values });
  };

  // 重置查询
  const handleReset = () => {
    form.resetFields();
    getList({ page: 1 });
  };

  useEffect(() => {
    fetchModules();
    getList({ page: 1 });
  }, []);

  const closeModalCb = () => {
    setSceneData(null);
    setShowScene(false);
    // 使用当前筛选条件重新获取数据
    const values = form.getFieldsValue();
    getList({ page: currentPage, filters: values });
  };

  const handleEdit = (record: any) => {
    setSceneData(record);
    setShowScene(true);
  };

  const handleDelete = (record: any) => {
    setDeletingRecord(record);
    setDeleteModalVisible(true);
  };

  const handleReorder = async (id: string, direction: "up" | "down") => {
    if (reorderingId) return;
    setReorderingId(id);
    try {
      const response = await post("/api/manage/scene-reorder", {
        id,
        direction,
      });
      if (response?.data?.code === 0) {
        const values = form.getFieldsValue();
        getList({ page: currentPage, filters: values });
      } else {
        console.error("排序调整失败:", response?.data?.msg);
      }
    } catch (error) {
      console.error("排序调整失败:", error);
    } finally {
      setReorderingId(null);
    }
  };

  const handleDeleteConfirm = async () => {
    if (!deletingRecord) return;
    try {
      const response = await post("/api/manage/scene-delete", {
        id: deletingRecord.id,
      });
      console.log("🚀 ~ handleDeleteConfirm ~ response:", response);
      if (response?.data?.code === 0) {
        setDeleteModalVisible(false);
        setDeletingRecord(null);
        getList({ page: 1 });
      }
    } catch (error) {
      console.error("🚀 ~ handleDeleteConfirm ~ error:", error);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setDeletingRecord(null);
  };

  return (
    <div style={{ padding: 24, background: "#f5f5f5", minHeight: "100vh" }}>
      <Card
        title={
          <Title level={3} style={{ margin: 0 }}>
            场景列表
          </Title>
        }
        extra={
          <Button type="primary" onClick={createScene}>
            创建场景
          </Button>
        }
      >
        {/* 查询表单 */}
        <Form
          form={form}
          layout="horizontal"
          style={{ marginBottom: 16 }}
          initialValues={{}}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="scene_name"
                label="场景名称"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Input placeholder="请输入场景名称" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="module_id"
                label="所属模块"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Select placeholder="请选择模块" allowClear>
                  {modules.map((module) => (
                    <Select.Option key={module.id} value={module.id}>
                      {module.module_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="permission_type"
                label="权限类型"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Select placeholder="请选择权限类型" allowClear>
                  <Select.Option value={PERMISSIONS.FREE}>
                    {PERMISSION_MAP[PERMISSIONS.FREE]}
                  </Select.Option>
                  <Select.Option value={PERMISSIONS.VIP}>
                    {PERMISSION_MAP[PERMISSIONS.VIP]}
                  </Select.Option>
                  <Select.Option value={PERMISSIONS.NORMAL}>
                    {PERMISSION_MAP[PERMISSIONS.NORMAL]}
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="scene_status"
                label="状态"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Select placeholder="请选择状态" allowClear>
                  <Select.Option value={STATUS.INUSE}>
                    {STATUS_MAP[STATUS.INUSE]}
                  </Select.Option>
                  <Select.Option value={STATUS.DISABLE}>
                    {STATUS_MAP[STATUS.DISABLE]}
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="is_recommend"
                label="是否推荐"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Select placeholder="请选择" allowClear>
                  <Select.Option value={true}>是</Select.Option>
                  <Select.Option value={false}>否</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end" gutter={16}>
            <Col>
              <Space>
                <Button onClick={handleReset}>重置</Button>
                <Button type="primary" onClick={handleSearch}>
                  查询
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>

        <Table
          dataSource={dataSource}
          columns={columns}
          rowKey="id"
          scroll={{ x: 1200 }}
          pagination={{
            current: currentPage,
            pageSize: 20,
            total: total,
            showSizeChanger: false,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条`,
            onChange: (page) => {
              const values = form.getFieldsValue();
              getList({ page, filters: values });
            },
          }}
        />
      </Card>
      <CreateModal
        data={sceneData}
        show={showScene}
        closeModalCb={closeModalCb}
      ></CreateModal>
      <Modal
        title="确认删除"
        open={deleteModalVisible}
        onOk={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        okText="确认"
        cancelText="取消"
      >
        <p>确定要删除这个场景吗？</p>
      </Modal>
    </div>
  );
}

export default List;
